<template>
  <hm-content title>
    <div class="mb20">
      <el-card>
        <el-input
          v-model="username"
          size="small"
          class="mr20"
          placeholder="请输入账号名"
          clearable
        ></el-input>
        <el-button
          size="small"
          class="mr20"
          :disabled="!username"
          type="primary"
          @click="unfreezing"
          >解冻</el-button
        >
        <el-button
          size="small"
          class="mr20"
          :disabled="!username"
          type="danger"
          @click="freezing"
          >冻结</el-button
        >
        <el-button
          size="small"
          class="mr20"
          :disabled="!username"
          type="primary"
          @click="setSuperAdmin"
          >权限设置</el-button
        >
      </el-card>
    </div>
    <div class="mb20 flex flex-end">
      <el-button type="primary" size="small" @click="search">查询</el-button>
    </div>
    <div>
      <el-table
        stripe
        border
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="username"
          label="用户账号"
        >
        <template slot-scope="scope">
          <div @click="quickSetUsername(scope.row.username)">{{scope.row.username}}</div>
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realname"
          label="用户名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="phone"
          label="手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="操作"
        >
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
              <el-button
                type="text"
                class="blue"
                size="small"
                @click="frozenUsername(scope.row)"
                >冻结用户</el-button
              >
              <el-button
                type="text"
                class="blue"
                size="small"
                @click="forceLogout(scope.row)"
                >强退用户</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChanges"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="权限设置"
      :visible.sync="dialogSetSuperAdmin"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="ml20 mb20">
        <div class="mb10">用户:{{ ruleForm.username }}</div>
        <div class="mb10">姓名:{{ ruleForm.realname }}</div>
        <div class="mb10">手机号:{{ ruleForm.phone }}</div>        
      </div>
      <el-form
        :model="ruleForm"
        :rules="ruleFormRules"
        ref="ruleForm"
        label-width="150px"
      >
        <div>
          <el-form-item class="mb10" label="商城超管:" prop="position">
            <el-radio-group v-model="ruleForm.superAdmin">
              <el-radio label="yes">允许</el-radio>
              <el-radio label="no">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="mb10" label="红包超管查看权限:" prop="position">
            <el-radio-group v-model="ruleForm.superReadPermission">
              <el-radio label="yes">允许</el-radio>
              <el-radio label="no">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="mb10" label="红包超管编辑权限:" prop="position">
            <el-radio-group v-model="ruleForm.superEditPermission">
              <el-radio label="yes">允许</el-radio>
              <el-radio label="no">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="mb10" label="红包超管脱敏权限:" prop="position">
            <el-radio-group v-model="ruleForm.superDesensitizedPermission">
              <el-radio label="yes">允许</el-radio>
              <el-radio label="no">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <el-button size="small" @click="dialogSetSuperAdmin = false"
            >取消</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      username: "",
      dialogSetSuperAdmin: false,
      ruleForm: {
        username: "",
        realname: "",
        phone: "",
        superAdmin: "",
        superReadPermission: "",
        superEditPermission: "",
        superDesensitizedPermission: "",
      },
      ruleFormRules: {},
    };
  },
  computed: {},
  watch: {},
  created() {
    this.onlineList();
  },
  mounted() {},
  methods: {
    async onlineList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      }
      const { code, result } = await this.$store.dispatch("onlineList",params);
      if (code === "0") {
        const { records, total } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.onlineList();
    },
    handleSizeChanges(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.onlineList();
    },
    search() {
      this.currentPage = 1;
      this.onlineList();
    },
    async frozenUsername(row) {
      this.$confirm("冻结用户 " + row.realname + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const params = {
          token: row.token,
        };
        this.$store.dispatch("frozenUsername", params).then((res) => {
          this.$message({
            message: " 操作成功",
            type: "success",
          });
          this.onlineList();
        });
      }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消操作'
          });       
        });
    },
    async forceLogout(row) {
      this.$confirm("强退用户 " + row.realname + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const params = {
          token: row.token,
        };
        this.$store.dispatch("forceLogout", params).then((res) => {
          this.$message({
            message: " 操作成功",
            type: "success",
          });
          this.onlineList();
        });
      }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消操作'
          });       
        });
    },
    async unfreezing() {
      await this.$store.dispatch("accountUnfreezing", {
        username: this.username,
      });
      this.$message({
        type: "success",
        message: "解冻成功",
      });
    },
    async freezing() {
     try { 
      const result = await this.$confirm("确认冻结账号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      if (result === "confirm") {
        await this.$store.dispatch("accountFreezing", {
          username: this.username,
        });
        this.$message({
          type: "success",
          message: "冻结成功",
        });
      }
     } catch (error) {
      this.$message({
            type: 'info',
            message: '取消操作'
          }); 
     }
    },
    async setSuperAdmin() {
      const { code, result } = await this.$store.dispatch("showSuperAdmin", {
        username: this.username,
      });
      if (result) {
        this.ruleForm.username = result.username;
        this.ruleForm.realname = result.realname;
        this.ruleForm.phone = result.phone;
        this.ruleForm.superAdmin = result.superAdmin;
        this.ruleForm.superReadPermission = result.superReadPermission;
        this.ruleForm.superEditPermission = result.superEditPermission;
        this.ruleForm.superDesensitizedPermission =
          result.superDesensitizedPermission;
        this.dialogSetSuperAdmin = true;
      } else {
        this.$message({
          type: "warning",
          message: "无账号信息,请重新输入账号",
        });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this[formName]));
          this.$store.dispatch("setSuperAdmin", params).then((res) => {
            if (res.code == "0") {
              this.$message({
                message: " 操作成功",
                type: "success",
              });
              this.dialogSetSuperAdmin = false;
            }
          });
        }
      });
    },
    quickSetUsername(username){
      this.username = username;
    }
  },
};
</script>
<style lang="scss" scoped>
</style>
